import Vue from 'vue';
import dayjs from 'dayjs';
import {
  errCodeMap,
} from '@/lib/errors';
import * as types from './types';
import api from '@/apis/summary';


const filterInit = {
  saasType: '',
  mediaType: '',
  mediaId: '',
  stime: dayjs().subtract(7, 'day')
    .format('YYYY-MM-DD'),
  etime: dayjs().subtract(1, 'day')
    .format('YYYY-MM-DD'),
  isEshop: 1,
  isSettlement: 1,
  contentTypeNewNum: 0,
};

const pageInfoInit = {
  page: 1,
  count: 10,
  total: 0,
};

export default {
  namespaced: true,
  state: {
    filter: {
      ...filterInit,
    },
    activeTabIndex: 0,
    summary: {
      overview: {},
      chartData: [],
    },
    table: [],
    pageInfo: {
      ...pageInfoInit,
    },
    timeout: 60 * 1000,
    tableLoading: false,
  },
  mutations: {
    [types.CHANGE_ACTIVE_TAB_INDEX](state, {
      activeTabIndex,
    }) {
      state.activeTabIndex = activeTabIndex;
    },
    [types.SET_STATISTIC_SUMMARY_FILTER](state, filter) {
      state.filter = {
        ...state.filter,
        ...filter,
      };
    },
    [types.RESET_STATISTIC_SUMMARY_FILTER](state) {
      state.filter = {
        ...filterInit,
      };
    },
    [types.SET_SUMMARY_DATA](state, {
      summary,
    }) {
      state.summary = {
        ...state.summary,
        ...summary,
      };
    },
    [types.SET_TABLE_LIST](state, {
      list,
    }) {
      state.table = list;
    },
    [types.SET_TABLE_PAGE_INFO](state, {
      pageInfo,
    }) {
      state.pageInfo = {
        ...state.pageInfo,
        ...pageInfo,
      };
    },
    [types.RESET_TABLE_PAGE_INFO](state) {
      state.pageInfo = {
        ...pageInfoInit,
      };
    },
    [types.SET_TABLE_LOADING](state, loading) {
      state.tableLoading = loading || false;
    },
  },
  actions: {
    async fetchStatSummary({
      state,
      commit,
    }) {
      const {
        saasType,
        mediaType,
        mediaId,
        stime,
        etime,
        isEshop,
        isSettlement,
        contentTypeNewNum,
      } = state.filter;

      const data = {
        saas_type: saasType === '全部' ? '' : saasType,
        media_type: mediaType === '全部' ? '' : mediaType,
        media_id: mediaId === '全部' ? '' : mediaId,
        stime,
        etime,
        is_eshop_settlement: isEshop,
        is_settlement: isSettlement,
        content_type_new: Number(contentTypeNewNum)  || 0,
        timeout: state.timeout,
      };

      api.dataOverview(data).then((res) => {
        if (res.head.code !== 0) {
          Vue.prototype.$tip.error(res.head.msg || errCodeMap[res.head.code] || '获取数据概览失败');

          return;
        }
        const {
          overview,
          list,
        } = res.result;
        commit(types.SET_SUMMARY_DATA, {
          summary: {
            overview: overview || [],
            chartData: list || [],
          },
        });
      })
        .catch(() => {
          Vue.prototype.$tip.error('获取数据概览失败');
        });
    },
    async fetchStatTableList({
      state,
      commit,
    }) {
      const {
        saasType,
        mediaType,
        mediaId,
        stime,
        etime,
        isEshop,
        isSettlement,
        contentTypeNewNum,
      } = state.filter;

      const data = {
        stime,
        etime,
        saas_type: saasType === '全部' ? '' : saasType,
        media_type: mediaType === '全部' ? '' : mediaType,
        media_id: mediaId === '全部' ? '' : mediaId,
        page: state.pageInfo.page,
        count: state.pageInfo.count,
        is_eshop_settlement: isEshop.toString() === '-1' ? '' : isEshop.toString(),
        is_settlement: isSettlement.toString() === '-1' ? '' : isSettlement.toString(),
        content_type_new: Number(contentTypeNewNum)  || 0,
        timeout: state.timeout,
      };
      api.detailsData(data).then((res) => {
        if (res.head.code !== 0) {
          Vue.prototype.$tip.error(res.head.msg || errCodeMap[res.head.code] || '获取数据明细失败');
          return;
        }
        commit(types.SET_TABLE_LIST, {
          list: res.result.list,
        });
        commit(types.SET_TABLE_PAGE_INFO, {
          pageInfo: {
            total: Number(res.pageinfo.total),
          },
        },);
      })
        .catch(() => {

        });
    },
    // 导出数据
    async exportSummaryStatistic({
      state,
      commit,
    }) {
      const {
        saasType,
        mediaType,
        mediaId,
        stime,
        etime,
        isEshop,
        isSettlement,
        contentTypeNewNum,
      } = state.filter;

      const data = {
        stime,
        etime,
        saas_type: saasType === '全部' ? '' : saasType,
        media_type: mediaType === '全部' ? '' : mediaType,
        media_id: mediaId === '全部' ? '' : mediaId,
        is_eshop_settlement: isEshop,
        is_settlement: isSettlement,
        content_type_new: Number(contentTypeNewNum) || 0,
        timeout: state.timeout,
      };
      api.dataExport(data).then((res) => {
        if (res.head.code !== 0) {
          this.$tip.error(errCodeMap[res.head.code] || '导出数据失败');
          return;
        }
        commit('common/SET_EXPORT_STATUS', {
          biz: 1,
          status: 2,
        }, {
          root: true,
        });
      });
    },
  },
  getters: {},
};
